import { createFileRoute } from '@tanstack/react-router'
import { CampaignPage } from '../../../../components/campaigns/CampaignPage'

/** One campaign: its units, follow-up, changes and settings. The tab lives in the URL. */
export const Route = createFileRoute('/$org/campaigns/$campaignUid/')({
  component: CampaignPage,
  validateSearch: (search: Record<string, unknown>) => ({
    tab: search.tab ? String(search.tab) : undefined,
  }),
})
